// Shared facts used by the About / Privacy / Terms pages. Change them here once.
export const SITE_NAME = "Vartha Business Network";
export const LAST_UPDATED = "2 October 2026";
// TODO: replace with your real support / grievance e-mail address.
export const CONTACT_EMAIL = "support@yourdomain.com";

// Language of the About / Privacy / Terms pages. "en" = always English, even when the site is switched to Tamil.
// The Tamil text is still in aboutContent.js / legalContent.js: set this to "follow" to make the pages follow the language button again.
export const INFO_PAGES_LANG = "en";
